import React, { useEffect, useState } from 'react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Typography,
  Grid,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import './home.sass';
import {apiCortex} from '../Components/ApiCall';
import { CircularProgress } from '@mui/material';

const IndicatorsCortex = () => {

    const [eventList, setEventList] = useState([]);
    const [selectedMatch, setSelectedMatch] = useState<string>('');
    const [totalTicketsSent, setTotalTicketsSent] = useState<number>(0);
    const [blockedPeople, setBlockedPeople] = useState(0);
    const [blockedByGate, setBlockedByGate] = useState<Record<string, number>>({});
    const [isLoading, setIsLoading] = useState(false);



    useEffect(() => {
        const fetchEvents = async () => {
          try {
            const response = await apiCortex.get('/all/events');
            setEventList(response.data);
          } catch (error) {
            console.error('Erro ao buscar eventos:', error);
            setEventList([]);
          }
        };
    
        fetchEvents();
    }, []);

    useEffect(() => {
        if (!selectedMatch) return;
      
        const fetchBlockedTickets = async () => {
          try {
            const response = await apiCortex.get(`/blocked/tickets/${selectedMatch}`);
            const blocked = response.data.result || {};
      
            const totalBlocked = Object.values(blocked).reduce<number>((acc, val) => {
              return acc + Number(val);
            }, 0);
      
            setBlockedByGate(blocked);
            setBlockedPeople(totalBlocked);
          } catch (error) {
            console.error('Erro ao buscar bloqueados por portão:', error);
            setBlockedByGate({});
            setBlockedPeople(0);
          }
        };
      
        fetchBlockedTickets();
      }, [selectedMatch]);
      
      
    useEffect(() => {
        const fetchTotalTicketsSent = async () => {
          if (!selectedMatch) return;

          setIsLoading(true);
      
          try {
            const response = await apiCortex.get(`/send/tickets/${selectedMatch}`);
            setTotalTicketsSent(response.data.totalTickets); 
          } catch (error) {
            console.error('Erro ao buscar total de ingressos enviados:', error);
            setTotalTicketsSent(0);
          }finally {
            setIsLoading(false);
          }
        };
        fetchTotalTicketsSent();
    }, [selectedMatch]);
      
    return (
        <Box p={4}>
            <Box mb={4} className="event-select">
                <FormControl fullWidth>
                    <InputLabel id="match-select-label">Selecionar Partida</InputLabel>
                    <Select
                        labelId="match-select-label"
                        id="match-select"
                        value={selectedMatch}
                        label="Selecionar Partida"
                        onChange={(e) => setSelectedMatch(e.target.value)}
                    >
                    {eventList.map((event: any) => {
                        const formattedDate = new Date(event.dataEvento).toLocaleDateString('pt-BR');
                        return (
                            <MenuItem key={event.cortexEventId} value={event.cortexEventId}>
                                {event.descricao} — {formattedDate}
                            </MenuItem>
                        );
                    })}

                    </Select>
                </FormControl>
            </Box>

            {isLoading ? (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="50vh"
            >
                <CircularProgress color="primary" size={60} />
            </Box>
            ) : (       

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                        backgroundColor: '#F8F9FA', 
                        color: '#2E2E2E',
                        padding: 3,
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <CheckCircleIcon sx={{ fontSize: 40, mb: 1 , color: '#1B4332' }} />
                        <Typography variant="h6" fontWeight={400}>Ingressos Enviados</Typography>
                        <Typography variant="h4" fontWeight={700}>
                        {totalTicketsSent}
                        </Typography>
                    </Box>
                </Grid>
       
                {Object.keys(blockedByGate).length > 0 ? (
                  Object.entries(blockedByGate).map(([gate, count]) => (
                <Grid item xs={12} md={6} key={gate}>
                  <Box
                    sx={{
                      backgroundColor: '#F8F9FA',
                      color: '#2E2E2E',
                      padding: 3,
                      borderRadius: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <BlockIcon sx={{ fontSize: 40, mb: 1, color: '#8B0000' }} />
                    <Typography variant="h6" fontWeight={400}>
                      Bloqueados - Portão {gate}
                    </Typography>
                    <Typography variant="h4" fontWeight={700} color="text.primary">
                      {count}
                    </Typography>
                  </Box>
                </Grid>
              ))
            ) : (
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: '#F8F9FA',
                    color: '#2E2E2E',
                    padding: 3,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <BlockIcon sx={{ fontSize: 40, mb: 1, color: '#8B0000' }} />
                  <Typography variant="h6" fontWeight={400}>Bloqueados</Typography>
                  <Typography variant="h4" fontWeight={700}>0</Typography>
                </Box>
              </Grid>
            )}
            </Grid>
            )}
        </Box>
    );
};

export default IndicatorsCortex;

